export function sortDevices(arr, caseInsensitive = true) {
  if (!Array.isArray(arr)) return [];
  return arr
    .slice()
    .sort((a, b) =>
      caseInsensitive
        ? a.localeCompare(b, undefined, { sensitivity: 'base' })
        : a.localeCompare(b),
    );
}
